<template>
  <div>
    <component
      v-if="isComponent"
      :is="isComponent"
      :view-bindings="viewBindings"
      :filestore="filestore"
      :widget="widget"
      class="content"
    />
  </div>
</template>

<script>
export default {
  props: {
    'widget': {
      type: Object,
      required: true
    },
    filestore: {
      type: [Object, String],
      required: true
    }
  },
  computed: {
    isComponent: function() {
      if (this.widget.widgetSettings.listType && this.widget.widgetSettings.viewType) {
        let listType = this.widget.widgetSettings.listType
        const listTypeParts = listType.split(('-'))
        if (listTypeParts.length === 2 && (listTypeParts[0] === 'latest' || listTypeParts[0] === 'featured')) {
          // Not using the updated blob structure. Caress the old structure.
          listType = listTypeParts[1]
        }

        return 'content-creator-content-list-' + listType
      }
      return null
    },
    listType: function() {
      return this.widget.widgetSettings.listType
    },
    viewType: function() {
      return this.widget.widgetSettings.viewType
    },
    viewBindings: function() {
      const productCarouselDisplay = (this.listType === 'wines' && this.viewType === 'carousel')
      const productCarouselViewBindings = {
        carouselClasses: 'products-carousel'
      }

      if (productCarouselDisplay) {
        return productCarouselViewBindings
      }
    },
    maxItems: function() {
      return this.widget.widgetSettings.maxItems
    }
  }
}
</script>
